module.exports = __webpack_public_path__ + "img/casepic1.067910aa.png";